import { Injectable } from '@angular/core';
import { LocationHttpService } from './location-http.service';

@Injectable({
    providedIn: 'root'
})
export class ModuleSearchService {

    constructor(private httpService: LocationHttpService) {
    }

    public getList(query) {
        return this.httpService.post('module/search/module-search', query);
    }
}
